import { gql } from '@apollo/client'

export const MUTATION_GENERATE_REPORT = gql`
  mutation generateReport($input: GenerateReportInput!) {
    generateReport(input: $input) {
      result
    }
  }
`
